<template>
  <div class="uploadClass">
    <el-dialog v-dialogDrag width="600px" title="文件上传" :visible.sync="showDialog" :before-close="close"
      :close-on-click-modal="false">
      <el-form ref="formData" label-width="100px" status-icon>
        <div class="webuploader">
          <el-row>
            <el-col :span="24">
              <div class="hspFilePicker-box" id="dropArea">
                <i class="el-icon-upload"></i>
                <div>将文件拖到此处或点击按钮选择文件</div>
                <div id="hspFilePicker">选择文件</div>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="opts.exts!=''">
            <el-col :span="24">
              <el-form-item label="文件格式">
                <span class="upload-exts">{{opts.exts}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="sizeLimit>0">
            <el-col :span="24">
              <el-form-item label="文件大小">
                <span class="color-danger">不能大于{{sizeLimit}}M。</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="up_fm_fileName!=''">
            <el-col :span="24">
              <el-form-item label="文件名称">
                {{up_fm_fileName}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="progressObj.show">
            <el-col :span="22">
              <el-form-item label="进度">
                <el-progress :text-inside="true" :stroke-width="18" :percentage="progressObj.percentage"
                  status="success"></el-progress>
                <div class="color-success">{{progressObj.action}}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="upload" :disabled="up_fm_fileName==''">上传<i
            class="el-icon-upload el-icon--right"></i></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ApiUploadFile, checkFile, mergeFile } from '@/api/common/upload'
import { getUserToken } from '@/api/common/auth'
import { dropFile } from '@/configs/functions'
export default {
  name: 'commUploader',
  props: {},
  data() {
    return {
      refTarget: '', //触发事件的对象
      opts: {
        isMulti: false, //是否支持多个附件，以列表展示
        exts: '', // 文件后缀名限制 .jpg.jpeg.png.pdf.mp4.avi.mp3
        refId: 0,
        refType: 0,
        guid: ''
      },
      accept: {
        type: String,
        default: '' //text video image
      },
      showDialog: false,
      //分片大小设置 2M
      chunkSize: 2 * 1024 * 1024,
      //分片上传重试次数
      chunkRetry: 5,
      //上传文件大小限制 500M
      sizeLimit: 0,// 500 * 1024 * 1024,
      up_fm_fileMd5: '',
      up_fm_size: 0,
      up_fm_fileName: '',
      up_fm_fileExt: '',
      up_fm_uploader: null,
      progressObj: {
        show: false,
        action: '',
        percentage: 0
      },
      uploadLoading: false,
      stopBtn: false
    }
  },
  created() {
    window.eventBus.$on('openUploader', info => {
      // console.log('openUploader', info, typeof (info.size) == "undefined")
      let opt = info.opt
      if (opt.refId == 0 && opt.guid == '') {
        this.$message({ message: '文件上传参数(refId或guid)未配置', type: 'warning' })
        return false
      }
      if (typeof (info.size) != "undefined") {
        if (info.size && info.size > 0) {
          this.sizeLimit = info.size
        }
      }
      // if (opt.refId > 0 && opt.refType > 0 && opt.guid != "") {
      //   opt.guid = ""
      // }
      this.opts = opt
      this.refTarget = info.targetId
      this.showDialog = true
      this.$nextTick(() => {
        if (!this.up_fm_uploader) {
          console.log('up_fm_uploader init ')
          this.initUpload()
        }
        dropFile('dropArea', this.addFileToQueue)
      })
    })
  },
  beforeDestroy() {
    window.eventBus.$off('openUploader')
  },
  mounted() { },
  methods: {
    addFileToQueue(e) {
      this.up_fm_uploader.addFiles(e)
    },
    initUpload() {
      WebUploader.Uploader.unRegister('beforeSendFile')
      WebUploader.Uploader.unRegister('beforeSend')
      WebUploader.Uploader.unRegister('afterSendFile')
      WebUploader.Uploader.register({
        name: 'beforeSendFile',
        'before-send-file': file => {
          console.log('beforeSendFile 计算文件md5,校验文件')
          this.uploadLoading = true
          this.stopBtn = true
          var deferred = WebUploader.Deferred()
          this.up_fm_uploader
            .md5File(file)
            .progress(percentage => {
              // 及时显示进度
              this.showProgress('计算文件MD5', parseInt(percentage * 100))
            })
            .then(fileMd5 => {
              this.showProgress('服务器校验...', 1)
              this.up_fm_fileMd5 = fileMd5
              this.up_fm_size = file.size
              this.up_fm_fileName = file.name
              this.up_fm_fileExt = file.ext
              this.up_fm_uploader.options.formData.fileMd5 = fileMd5
              // 添加完整文件的md5值
              file.wholeMd5 = fileMd5
              var chkData = {
                FileMd5: this.up_fm_fileMd5,
                FileName: this.up_fm_fileName,
                Size: this.up_fm_size,
                Type: file.type,
                Ext: file.ext,
                ReferId: this.opts.refId,
                ReferType: this.opts.refType,
                TempGuid: this.opts.guid
              }
              checkFile(chkData).then(response => {
                console.log(response)
                var flag = response.data.flag
                //1需要重新上传，2.传过部分 3.已经传过完整文件
                if (flag == 1) {
                  this.showProgress('校验完成，开始上传', 0)
                  file.wholeMd5 = fileMd5
                  file.chunkMd5s = []
                  deferred.resolve()
                } else if (flag == 2) {
                  // 已经传过的切片md5值列表
                  this.showProgress('已分块，开始上传', 0)
                  file.wholeMd5 = fileMd5
                  file.chunkMd5s = response.data.chunkMd5s
                  deferred.resolve()
                } else if (flag == 3) {
                  this.showProgress('重复文件，秒传成功', 100)
                  //跳过文件后，reject错误反馈到uploadError方法中，然后其中调用file.skipped判断是错误还是自动跳过
                  this.up_fm_uploader.skipFile(file)
                  console.log('重复文件，跳过该文件')
                  deferred.reject()
                  // deferred.resolve(); 这里不能用resolve，否则会继续运行后面的上传事件
                } else {
                  this.showProgress(response.data.msg, 0)
                  console.log('校验失败！请检查网络。')
                  this.$message({
                    message: '校验失败,' + response.data.msg,
                    type: 'error'
                  })
                  this.uploadLoading = false
                  this.stopBtn = false

                  file.msg = response.data.msg
                  // this.up_fm_uploader.reset()
                  deferred.reject()
                }
              })
              // .catch(error => {
              //   console.log(error);
              //   deferred.reject();
              // });
            })
          return deferred.promise()
        }
      })
      WebUploader.Uploader.register({
        name: 'beforeSend',
        'before-send': block => {
          console.log('beforeSend')
          var deferred = WebUploader.Deferred()
          var file = block.file
          var chunk = block.chunk
          var chunks = block.chunks
          if (chunks > 1) {
            console.log("需要分片，分片数" + chunks)
            //文件大于chunksize 分片上传
            this.up_fm_uploader
              .md5File(block.blob)
              .progress(percentage => {
                //分片MD5计算可以不知道计算进度
                this.showProgress('分块MD5', parseInt(percentage * 100))
              })
              .then(chunkMd5 => {
                block.chunkMd5 = chunkMd5
                var chunkMd5s = file.chunkMd5s
                var exists = false
                if (typeof chunkMd5s == 'undefined') {
                  exists = false
                } else {
                  exists = chunkMd5 == chunkMd5s[chunk] ? true : false
                }
                if (exists) {
                  this.showProgress(
                    '分块' + chunk + '/' + chunks + '已存在，跳过',
                    100
                  )
                  deferred.reject()
                } else {
                  this.showProgress('上传分块' + chunk + '/' + chunks, 0)
                  deferred.resolve()
                }
                deferred.resolve()
              })
          } else {
            this.showProgress('上传文件', 0)
            console.log("不需要分片，直接上传")
            // 未分片文件上传
            block.chunkMd5 = file.wholeMd5
            this.up_fm_uploader.options.formData.chunkMd5 = file.wholeMd5
            deferred.resolve()
          }
          this.up_fm_uploader.options.formData.fileMd5 = file.wholeMd5
          return deferred.promise()
        }
      })
      WebUploader.Uploader.register({
        name: 'afterSendFile',
        'after-send-file': file => {
          console.log('afterSendFile')
          var deferred = WebUploader.Deferred()
          this.showProgress('合并文件', 0)
          // 如果分块上传成功,则通知后台合并分块
          var megData = {
            ReferId: this.opts.refId,
            ReferType: this.opts.refType,
            TempGuid: this.opts.guid,
            IsMulti: this.opts.isMulti,
            FileMd5: this.up_fm_fileMd5,
            FileName: this.up_fm_fileName,
            Ext: this.up_fm_fileExt,
            Type: file.type
          }
          // console.log(file, megData);
          mergeFile(megData)
            .then(response => {
              if (response.data.result) {
                this.showProgress('合并成功', 100)
                deferred.resolve()
              } else {
                this.showProgress('合并失败', 0)
                console.log('文件合并失败', response.data.msg)
                deferred.reject()
              }
              this.up_fm_uploader.reset()
              this.up_fm_fileMd5 = ''
              this.up_fm_size = 0
              this.up_fm_fileName = ''
              this.up_fm_fileExt = ''
              console.log('合并结束')
            })
            .catch(error => {
              console.log('merge error', error)
              deferred.reject()
            })
          return deferred.promise()
        }
      })
      this.up_fm_uploader = WebUploader.create({
        auto: false, // 选完文件后，是否自动上传
        // swf: "/static/lib/webuploader/Uploader.swf", // swf文件路径
        swf: '~/js/webuploader/Uploader.swf', // swf文件路径
        server: ApiUploadFile, // 文件接收服务端
        pick: {
          id: '#hspFilePicker',
          multiple: false // 只能选择一个文件上传
        },
        // accept: this.getAccept(this.accept), // 允许选择文件格式。
        threads: 3,
        fileNumLimit: 1, // 限制上传个数
        chunked: true, //分片上传
        chunkSize: 2 * 1024 * 1024, //分片大小

        // fileSingleSizeLimit: this.sizeLimit,   //设定单个文件大小
        // fileSizeLimit: this.sizeLimit,//限制大小10M，所有被选文件，超出选择不上

        compress: false, //图片不压缩
        resize: false,
        duplicate: true // 重复上传
      })
      this.up_fm_uploader.on('beforeFileQueued', file => {
        this.progressObj = {
          show: false,
          action: '',
          percentage: 0
        }
        this.up_fm_uploader.reset()
      })
      // 当有文件被添加进队列的时候，添加到页面预览
      this.up_fm_uploader.on('fileQueued', file => {
        var toContinue = true
        if (this.sizeLimit > 0) {
          var maxSize = this.sizeLimit * 1024 * 1024
          if (file.size > maxSize) {
            var msg = '文件大小不能超过' + this.sizeLimit + 'M。'
            this.$message({ message: msg, type: 'warning' })
            this.up_fm_uploader.removeFile(file)
            this.up_fm_uploader.reset()
            toContinue = false
          }
        }
        if (toContinue) {
          // this.fileInfo = file;
          this.up_fm_size = file.size
          this.up_fm_fileName = file.name
          this.up_fm_fileExt = file.ext
        }
        else {
          this.up_fm_size = 0
          this.up_fm_fileName = ''
          this.up_fm_fileExt = ''
        }
        // this.$emit("fileChange", file);
      })
      this.up_fm_uploader.on('uploadBeforeSend', (block, data, headers) => {
        const { token, valid } = getUserToken()
        if (token && valid) {
          headers['Authorization'] = `Bearer ${token}`
        }
        headers['Accept'] = '*/*'
        headers['Access-Control-Allow-Methods'] = 'GET,POST'
        var file = block.file
        data.fileMd5 = file.wholeMd5
        data.chunkMd5 = block.chunkMd5
        data.ext = file.ext
        data.chunk = block.chunk
      })
      //每次切片上传完成之后的判断
      this.up_fm_uploader.on('uploadAccept', (object, ret) => {
        console.log('uploadAccept', object, ret)
      })
      this.up_fm_uploader.on('uploadStart', file => {
        console.log('uploadStart')
        // 在这里可以准备好formData的数据
        //this.up_fm_uploader.options.formData.key = this.keyGenerator(file);
      })
      // 文件上传过程中创建进度条实时显示。
      this.up_fm_uploader.on('uploadProgress', (file, percentage) => {
        console.log("uploadProgress", file, percentage);
        this.showProgress('上传中', parseInt(percentage * 100))
      })
      this.up_fm_uploader.on('uploadSuccess', (file, response) => {
        console.log('uploadSuccess', file, response)
        this.uploadLoading = false
        this.stopBtn = false
        this.showProgress('上传成功，合并文件', 100)
        // var opt = this.opts;
        // this.$emit("success", opt);
      })
      this.up_fm_uploader.on('uploadError', (file, reason) => {
        console.log('uploadError', file, reason)
        this.uploadLoading = false
        this.stopBtn = false
        if (file.msg && file.msg + '' != '') {
          console.log('error message', file.msg)
          this.$message({ message: file.msg, type: 'error' })
          this.complete()
        }
        // file.skipped 对照checkFile中的重复文件秒传中的跳过操作
        else if (file.skipped != 'undefined' && file.skipped) {
          console.log('file.skipped')
          this.complete()
        } else {
          this.$message({ message: '文件上传失败', type: 'error' })
          this.complete()
          // this.$emit("uploadError", file, reason);
        }
      })
      this.up_fm_uploader.on('error', type => {
        console.log('error')
        this.uploadLoading = false
        this.stopBtn = false
        let errorMessage = ''
        if (type === 'F_EXCEED_SIZE') {
          errorMessage = `文件大小不能超过${this.fileSingleSizeLimit /
            (1024 * 1000)}M`
        } else if (type === 'Q_EXCEED_NUM_LIMIT') {
          errorMessage = '文件上传已达到最大上限数'
        } else {
          errorMessage = `上传出错！请检查后重新上传！错误代码${type}`
        }
        console.error(errorMessage)
        this.$message({ message: 'error' + errorMessage, type: 'error' })
      })
      this.up_fm_uploader.on('uploadComplete', (file, response) => {
        console.log('uploadComplete')
        this.complete()
      })
    },
    showProgress(action, percent) {
      this.progressObj = {
        show: true,
        action: action,
        percentage: percent
      }
    },
    upload() {
      if (this.up_fm_uploader.getFiles()[0] != null) {
        const curExts = (this.opts.exts + '').toLowerCase()
        if (
          curExts != '' &&
          curExts.indexOf(this.up_fm_fileExt.toLowerCase()) < 0
        ) {
          this.$message({
            message: '文件格式不正确，请重新选择',
            type: 'warning'
          })
          this.up_fm_uploader.reset()
        } else {
          this.up_fm_uploader.upload(this.up_fm_uploader.getFiles()[0].id)
          this.uploadLoading = true
          this.stopBtn = true
        }
      } else {
        this.$message({ message: '请选择需要上传的文件', type: 'warning' })
      }
    },
    stop() {
      this.up_fm_uploader.cancelFile(this.up_fm_uploader.getFiles()[0].id)
    },
    complete() {
      const opt = this.opts
      window.eventBus.$emit('uploadComplete', {
        targetId: this.refTarget,
        opt: this.opts
      })
      this.close()
    },
    close() {
      this.uploadLoading = false
      this.stopBtn = false
      this.progressObj = {
        show: false,
        action: '',
        percentage: 0
      }
      this.up_fm_fileMd5 = ''
      this.up_fm_size = 0
      this.up_fm_fileName = ''
      this.up_fm_fileExt = ''
      this.up_fm_uploader.reset()
      this.showDialog = false
    },
    getAccept(accept) {
      switch (accept) {
        case 'text':
          return {
            title: 'Texts',
            exteensions: 'doc,docx,xls,xlsx,ppt,pptx,pdf,txt',
            mimeTypes: '.doc,docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt'
          }
          break
        case 'video':
          return {
            title: 'Videos',
            exteensions: 'mp4',
            mimeTypes: '.mp4'
          }
          break
        case 'image':
          return {
            title: 'Images',
            exteensions: 'gif,jpg,jpeg,bmp,png',
            mimeTypes: '.gif,.jpg,.jpeg,.bmp,.png'
          }
          break
        default:
          return accept
          break
      }
    }
  }
}
</script>

<style>
.uploadClass .el-dialog__body {
  min-height: 200px !important;
}
.progress-action {
  float: left;
}
.webuploader {
  margin-top: 15px;
}
.webuploader .el-row,
.webuploader .el-form-item {
  margin: 0px;
}
.webuploader .el-progress {
  position: unset;
  line-height: unset;
}
.webuploader-element-invisible {
  position: absolute !important;
  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
  clip: rect(1px, 1px, 1px, 1px);
}
.webuploader-pick {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  /* padding: 5px 10px;
  font-size: 13px;
  border-radius: 3px; */
  overflow: hidden;
  text-align: center;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  line-height: 14px;
}
.webuploader-pick + div {
  min-width: 72px;
  min-height: 28px;
}
.webuploader-pick:active {
  background: #3a8ee6;
  border-color: #3a8ee6;
}
.webuploader-pick-hover {
  background: #66b1ff;
  border-color: #66b1ff;
}
.webuploader-pick-disable {
  opacity: 0.6;
  pointer-events: none;
}
.upload-exts {
  padding: 5px 0px;
  color: #df113a !important;
}
</style>
